import React, { useState } from 'react'
import { NoViewData } from '../../../../core/global/EmptyState'
import { Box } from '@mui/material'
import { KeyboardBackspace } from '@mui/icons-material';

export const NoData = ({location, history}) => {
     const [hovered, setHovered] = useState(false);

    return (
        <Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center" flexDirection="column" gap="16px">
            <NoViewData/>
            <Box display="flex" flexDirection="column" alignItems="center" gap="8px">
                <Box sx={{ color: '#42465A', textTransform: "capitalize", fontSize: '16px', fontWeight: '600' }}>{`Oops! ${location.split("/")[3]} Not Found`}</Box>
                <Box color="#747D8E" fontSize="14px">{`This ${location.split("/")[3]} might have been removed or is currently unavailable!`}</Box>
            </Box>
            <Box
                onClick={() => history.push(`/psl/publication?tab=${location.split("/")[3]}`)}
                sx={{
                    display:"flex",
                    alignItems:"center",
                    p:"8px 16px",
                    bgcolor:"#B0BACC",
                    borderRadius:"100px",
                    mt:"8px",
                    gap: hovered ? "8px" : "0px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    width: "fit-content",
                    overflow: "hidden",
                }}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
            >
                <Box
                    sx={{
                        width: hovered ? "24px" : "0px", 
                        opacity: hovered ? 1 : 0,
                        transition: "width 0.3s ease, opacity 0.3s ease",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <KeyboardBackspace />
                </Box>
                <Box fontSize="16px" sx={{ whiteSpace: "nowrap" }}>
                    Go Back!
                </Box>
            </Box>

        </Box>
    )
}
